import React, { useEffect, useState } from "react";
import { api } from "@/api";
import { Check } from "lucide-react";

export default function BpCatalog() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/bp/catalog").then((r) => setData(r.data)).catch(() => setData({ plans: [] })); }, []);
  return (
    <div className="p-6 lg:p-10 space-y-6" data-testid="bp-catalog">
      <div>
        <div className="text-xs uppercase tracking-[0.3em] text-[#868E96] font-bold mb-2">// Lecture seule</div>
        <h1 className="font-display text-4xl font-black tracking-tighter">Catalogue PAG Business Manager</h1>
        <p className="text-sm text-[#495057] mt-2">{data?.note || "Tarifs publics HT."}</p>
      </div>
      {!data ? <div className="text-sm text-[#868E96]">Chargement…</div> : (
        <div className="grid md:grid-cols-2 xl:grid-cols-4 gap-4">
          {data.plans.map((p) => (
            <div key={p.key} className="bg-white border border-[#DEE2E6] p-5 flex flex-col" data-testid={`bp-plan-${p.key}`} style={{ borderTopWidth: 4, borderTopColor: p.color || "#002FA7" }}>
              <div className="text-[10px] uppercase tracking-[0.25em] font-bold text-[#868E96]">{p.tagline}</div>
              <div className="font-display font-black text-2xl tracking-tight mt-1">{p.name}</div>
              <div className="mt-3 font-display font-black text-3xl">{p.monthly_price != null ? `${Number(p.monthly_price).toLocaleString("fr-FR")} €` : "—"}<span className="text-xs font-semibold text-[#868E96]"> HT / mois</span></div>
              {p.annual_price != null && <div className="text-xs text-[#495057]">ou {Number(p.annual_price).toLocaleString("fr-FR")} € HT / an</div>}
              <ul className="mt-4 space-y-1.5 text-xs flex-1">
                {(p.features || []).map((f) => <li key={f} className="flex items-start gap-1.5"><Check className="h-3.5 w-3.5 text-[#059669] mt-0.5 shrink-0" />{f}</li>)}
              </ul>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
